// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fctl-resource-link {
  display: inline-flex;
  align-items: center;
}

.fctl-resource-link.fctl-resource-link__full {
  display: flex;
}

.fctl-resource-link .fctl-resource-link__text {
  text-wrap: nowrap;
  overflow-x: hidden;
}

.fctl-resource-link .pf-v6-c-button {
  /* The copy name button is hidden by default */
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}

.fctl-resource-link:hover .pf-v6-c-button {
  /* Makes the copy name button visible when hovering over the name */
  clip: initial;
  clip-path: initial;
  overflow: visible;
  white-space: initial;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/common/ResourceLink.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;EACnE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".fctl-resource-link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.fctl-resource-link.fctl-resource-link__full {\n  display: flex;\n}\n\n.fctl-resource-link .fctl-resource-link__text {\n  text-wrap: nowrap;\n  overflow-x: hidden;\n}\n\n.fctl-resource-link .pf-v6-c-button {\n  /* The copy name button is hidden by default */\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.fctl-resource-link:hover .pf-v6-c-button {\n  /* Makes the copy name button visible when hovering over the name */\n  clip: initial;\n  clip-path: initial;\n  overflow: visible;\n  white-space: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
